import { Component, OnInit } from '@angular/core';
import { ValueService } from 'src/app/services/value.service';

@Component({
  selector: 'app-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.css']
})
export class TermsPageComponent implements OnInit {

  constructor(private getdata:ValueService) { }

  ngOnInit(): void {
    this.getdata.isVisibleSource.next(true);
  }

}
